'use client'

import { urlSafeProfilePath } from '@/helpers/url-safe-profile-path'
import Link from 'next/link'
import { createElement } from 'react'

export default function ProfileTabs({
  user,
  userStats,
  session,
  currentTab,
  tabComponents,
  games = [],
  className = '',
  sortedPast,
  sortedFuture,
}) {
  const tabOptions = [
    {
      mode: 'driver',
      label: 'Driver Profile',
      propName: 'driverGames', // Check if they have games
    },
    {
      mode: 'livery',
      label: 'Livery Designer',
      propName: 'liveryDesignerConfig',
    },
    {
      mode: 'broadcaster',
      label: 'Broadcaster',
      propName: 'broadcasterConfig',
    },
    {
      mode: 'commentator',
      label: 'Commentator',
      propName: 'commentatorConfig',
    },
  ]

  return (
    <div className={`profile-tabs ${className}`}>
      <div className="hidden w-full items-center gap-5 desktop-sm:flex">
        {tabOptions.map((tab) => {
          let isVisible = false
          if (tab.mode === 'livery') {
            isVisible =
              user[tab.propName] &&
              user.liveryDesigns &&
              user.liveryDesigns.length > 0
          } else {
            const propValue = user[tab.propName]
            isVisible = Array.isArray(propValue)
              ? propValue.length > 0
              : !!propValue
          }

          if (!isVisible) return null
          return (
            <Link
              key={`${tab.mode}-tab`}
              href={urlSafeProfilePath({ ...user, profileType: tab.mode })}
              className={`rounded-full px-6 py-3 text-p-2 font-semibold ${
                currentTab === tab.mode && 'bg-shades-0 text-neutral-blue-900'
              }`}
              data-istestflow={`${tab.mode}ProfileLink`}
            >
              {tab.label}
            </Link>
          )
        })}
      </div>

      {createElement(tabComponents[currentTab], {
        user,
        userStats,
        userProfile:
          user[tabOptions.find((tab) => tab.mode === currentTab)?.propName],
        session,
        sortedPast,
        sortedFuture,
        games,
        communities: user.communityMemberships?.map((cm) => cm.community) || [],
      })}
    </div>
  )
}
